<compartido-ficha [configuracion]="configFicha">
  <compartido-tabla
    class="tabla"
    [configuracion]="configTabla"
    [datos]="filas"
  ></compartido-tabla>
</compartido-ficha>
